// Shared queue helper
import moment from 'moment'

function hasSharedStamp() {
    return window.localStorage.getItem('shared_stamp') !== null;
}

function saveSharedStamp(sid) {
    window.localStorage.setItem('shared_stamp', JSON.stringify({
        sid,
        ts: moment().add(10, 'seconds').toDate()
    }));
}

function updateStampTime(sid) {
    let raw = JSON.parse(window.localStorage.getItem('shared_stamp'));
    raw.ts = moment().add(10, 'seconds').toDate();

    window.localStorage.setItem('shared_stamp', JSON.stringify(raw));
}

function isValidStamp() {
    const raw = JSON.parse(window.localStorage.getItem('shared_stamp'));

    const then = moment(raw.ts);

    return then.isAfter(moment());
}

function clearStamp() {
    window.localStorage.removeItem('shared_stamp');
}

function getStampSid() {
    const raw = JSON.parse(window.localStorage.getItem('shared_stamp'));

    return raw.sid;
}

function getStampDate() {
    const raw = JSON.parse(window.localStorage.getItem('shared_stamp'));

    return raw.ts;
}

export default {
    hasSharedStamp,
    isValidStamp,
    clearStamp,
    getStampSid,
    saveSharedStamp,
    updateStampTime,
    getStampDate
}